(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["password-notice"] && !Shopify.designMode) return;
  try {
    (function () {
    function pad(value) {
      return value < 10 ? '0' + value : String(value);
    }

    document.querySelectorAll('[data-countdown-root]').forEach(function (root) {
      const timer = root.querySelector('[data-countdown-timer]');
      if (!timer) return;

      const target = new Date(timer.dataset.countdown).getTime();

      if (isNaN(target)) {
        root.hidden = true;
        return;
      }

      const label = root.querySelector('[data-countdown-label]');
      const expired = root.querySelector('[data-countdown-expired]');
      const days = root.querySelector('[data-countdown-days]');
      const hours = root.querySelector('[data-countdown-hours]');
      const minutes = root.querySelector('[data-countdown-minutes]');
      const seconds = root.querySelector('[data-countdown-seconds]');
      let interval = null;

      function finish() {
        if (interval) {
          window.clearInterval(interval);
          interval = null;
        }
        timer.hidden = true;
        if (label) label.hidden = true;
        if (expired) {
          expired.hidden = false;
        } else {
          root.hidden = true;
        }
      }

      function tick() {
        const remaining = target - Date.now();

        if (remaining <= 0) {
          finish();
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        days.textContent = String(Math.floor(totalSeconds / 86400));
        hours.textContent = pad(Math.floor(totalSeconds / 3600) % 24);
        minutes.textContent = pad(Math.floor(totalSeconds / 60) % 60);
        seconds.textContent = pad(totalSeconds % 60);
      }

      tick();
      interval = window.setInterval(tick, 1000);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
